import { getLocalizedDate } from '@va/util/helpers';
import dayjs, { Dayjs } from 'dayjs';
import { CalendarDate } from '../types';
import { DATEPICKER_FORMATTER, DATEPICKER_SEPARATOR } from './constants';

export const getPreviousDate = (date: Dayjs) => {
  const display = [];
  for (let i = 0; i <= date.date(0).day(); i++) {
    display.push(date.date(0).subtract(i, 'day'));
  }
  return display.sort((a, b) => a.date() - b.date());
};

export const getCurrentDate = (date: Dayjs) => {
  return Array.from(
    {
      length: date.daysInMonth(),
    },
    (v, k) => date.date(k + 1),
  );
};

export const getNextDate = (date: Dayjs) => {
  const display = [];
  for (let i = 1; i <= 42 - (getPreviousDate(date).length + date.daysInMonth()); i++) {
    display.push(date.date(i).month(date.month()).add(1, 'month'));
  }
  return display;
};

export const formatDatepickerValue = ({ previous, next, locale }: { previous: Dayjs; next: Dayjs; locale: string }) => {
  let start = previous;
  let end = next;
  if (next.isBefore(previous)) {
    start = next;
    end = previous;
  }

  return `${getLocalizedDate(start.unix(), locale)}${DATEPICKER_SEPARATOR}${getLocalizedDate(end.unix(), locale)}`;
};

export const getMonths = (year = dayjs().year()) => {
  const currentMonth = dayjs().year() === year ? dayjs().month() : 11;

  return Array.from({ length: currentMonth + 1 }, (_, i) => dayjs().month(i).format(DATEPICKER_FORMATTER.month));
};

export const sortDates = (dateArray: [Dayjs, Dayjs]): [Dayjs, Dayjs] => {
  const [started, ended] = dateArray;
  const s = started?.isAfter(ended) ? ended : started;
  const e = started?.isAfter(ended) ? started : ended;
  return [s?.startOf('day'), e?.endOf('day')];
};

export const getBetweenRange = (date: CalendarDate, { previous, next }: { previous: Dayjs; next: Dayjs }) => {
  let pattern: '()' | '[]' | '[)' | '(]';

  if (previous.isAfter(next, 'date')) {
    pattern = '(]';
  } else {
    pattern = '[)';
  }
  return !!(date.isBetween(previous, next, 'date', pattern) && !date.off);
};
